export const RoutePath = {
  ADMIN: '/admin',
  ECG: '/ecg',
  PPG: '/ppg',
  PATIENTS: '/patients',
  PATIENT_DETAIL: '/patient-info',
  PRACTICE: '/practice',
  DASHBOARD: '/dashboard',
  STUDY: '/study',
  ECG_ANALYZE: '/ecg-analysis',
  CONNECT_FACILITY: '/connect-facility',
  CONNECT_PATIENT: '/connect-patient',
  SHARED_ECG: '/shared-ecg/:id',
  REQUESTS: '/requests',
  PARTNER_CONNECT: '/partner-connect',
  ALL: '*',
} as const;
